import React, { useState } from "react";
import { db } from "../lib/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const Subscriptions = () => {
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [status, setStatus] = useState({ success: false, message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ success: false, message: "" });

    if (!formData.name || !formData.email) {
      setStatus({ success: false, message: "Please enter your name and email." });
      return;
    }

    try {
      await addDoc(collection(db, "subscriptions"), {
        name: formData.name,
        email: formData.email,
        subscribedAt: serverTimestamp(),
      });

      setStatus({ success: true, message: "You're now subscribed!" });
      setFormData({ name: "", email: "" });
    } catch (error) {
      console.error("Error adding subscription: ", error);
      setStatus({ success: false, message: "Subscription failed. Try again!" });
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-black text-white shadow-lg rounded-md">
      <h2 className="text-2xl font-bold text-center mb-2">Stay Ahead with Exclusive Auto Updates</h2>
      <p className="text-center text-gray-300 mb-4">
        Get the latest car news, expert maintenance tips, and special offers delivered straight to your inbox.  
        Subscribe now and be the first to know what's trending in the automobile world!
      </p>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-semibold">Your Name</label>
          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border border-gray-600 bg-gray-900 text-white p-2 rounded focus:ring focus:ring-blue-500"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-semibold">Email Address</label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border border-gray-600 bg-gray-900 text-white p-2 rounded focus:ring focus:ring-blue-500"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-blue-600 text-white p-2 rounded shadow-md hover:bg-blue-700 transition-all"
        >
          Subscribe Now
        </button>
        {status.message && (
          <p className={`text-center mt-2 ${status.success ? "text-green-400" : "text-red-400"}`}>
            {status.message}
          </p>
        )}
      </form>
    </div>
  );
};

export default Subscriptions;
